import { z } from '@bonanza-social/toolkit/api';
import { PromoSchema } from '@bonanza-social/promos';

export const RegistrationOffersResponseSchema = z.object({
  items: z.array(PromoSchema),
});

export type Promotion = z.infer<typeof PromoSchema>;
